import { render, staticRenderFns } from "./TranslateWorld.vue?vue&type=template&id=40234c3a&"
import script from "./TranslateWorld.vue?vue&type=script&lang=js&"
export * from "./TranslateWorld.vue?vue&type=script&lang=js&"
import style0 from "./TranslateWorld.vue?vue&type=style&index=0&id=40234c3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports